import React, { AllHTMLAttributes, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import Title from "../_CMPT/Title";
// import XtSvg from "@/components/Xt/Svg";
// import passwordSetImg from "@/assets/images/account/a-icon-4.svg";
// import AntiPhishingCodeImg from "@/assets/images/account/AntiPhishingCodeImg.svg";
import Link from "next/link";
import C2CModal from "@/components/App/C2CModal";
import { useRouter } from "next/router";
interface PasswordSetProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
const { useTranslation } = Hooks;

const PasswordSet: React.FC<PasswordSetProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  const { userInfo } = store.user;
  const [pushName, setPushName] = useState("");
  const [visible, setVisible] = useState(false);
  /** useMemo */
  const showPwdLevelNew = useMemo(() => {
    const n = userInfo?.loginPwdLevel || 0;
    const level = Math.min(n, 5);
    const color = level < 3 ? "red" : level === 3 ? "orange" : "green";
    const range = level < 3 ? t("account.Low") : level === 3 ? t("account.Medium") : t("account.High");
    return (
      <>
        <p className={styles["ll-pp"]}>{t("account.PasswordStrength")}:</p>
        <div className={cx(styles["ll-safe-level"], styles[`ll-safe-level-${color}`])}></div>
        <div className={cx(styles["ll-safe-level"], level === 3 && styles["ll-safe-level-orange"], level > 3 && styles["ll-safe-level-green"])}></div>
        <div className={cx(styles["ll-safe-level"], level > 3 && styles["ll-safe-level-green"])}></div>
        <p className={cx(styles["mx-2"], styles["ll-pp"], styles[`ll-safe-leveltext-${color}`])}>{range}</p>
      </>
    );
  }, [userInfo]);
  /** method */
  const changePushName = (pushName: string) => {
    setPushName(pushName);
    setVisible(true);
  };
  const changeVerify = () => {
    router.push(pushName);
  };
  return (
    <div className={cx(styles.accountSet, className)}>
      <Title title={t("account.PasswordSetting")}></Title>
      {/* 登录密码 */}
      <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
        <div className={styles["account_list_common_left"]}>
          {/* <div>
            <img src={passwordSetImg} alt="" />
          </div> */}
          <div className={styles["account_sign"]}>
            <div className={styles["account_sign_header"]}>
              <span className={styles["account_sign_header_tit"]}>{t("account.loginPwd")}</span>
              
            </div>
            <div className={styles["account_sign_temp"]}>
            {userInfo && userInfo.loginPwdLevel != 0 ? (
                <span className={styles["showlever"]}>
                  {/* 密码强度展示 */}
                  {showPwdLevelNew}
                </span>
              ) : (
                <span className={styles["text-danger"]}>{t("account.NotSet")}</span>
              )}
            </div>
            <div className={styles["account_sign_footer"]}>
              <span className={styles["account_sign_header_desc"]}>{t("account.UsedforsecurityVerification")}</span>
            </div>
          </div>
        </div>
        <div className={styles["account_list_common_right"]}>
          <span
            className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}
            onClick={() => changePushName("/accounts/user/login-password")}
          >
            {t("account.change")}
          </span>
        </div>
      </div>

      {/* 防钓鱼码 */}
      <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
        <div className={styles["account_list_common_left"]}>
          {/* <div>
            <img src={AntiPhishingCodeImg} alt="" />
          </div> */}
          <div className={styles["account_sign"]}>
            <div className={styles["account_sign_header"]}>
              <span className={styles["account_sign_header_tit"]}>{t("account.AntiPhishingCode")}</span>
              
            </div>
            <div className={styles["account_sign_temp"]}>
            <span className={styles["account_sign_header_tip_mb"]}>
                <span className={cx(!userInfo?.antiFishingCode ? styles["noBinding"] : styles["binding"])}>
                  {!userInfo?.antiFishingCode ? t("account.noBinding") : ""}
                </span>
              </span>
            </div>
            <div className={styles["account_sign_footer"]}>
              <span className={styles["account_sign_header_desc"]}>{t("account.sentToYouContains")}</span>
            </div>
          </div>
        </div>
        <div className={styles["account_list_common_right"]}>
          <Link href={"/accounts/user/anti-phishing"}>
            {!userInfo?.antiFishingCode ? (
              <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_binding"])}>{t("account.Set")}</span>
            ) : (
              <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])}>{t("account.change")}</span>
            )}
          </Link>
        </div>
      </div>

      <C2CModal visible={visible} changeVisible={() => setVisible(false)} changeVerify={changeVerify}></C2CModal>
    </div>
  );
};
export default observer(PasswordSet);
